/**
 * <strong>Purpose:</strong> <br>
 * This mixin provides the ability to perform sizing of the icon and text related nodes.
 * <br><br>
 * <strong>Contract:</strong> <br>
 * <em>Attach-point:</em> contentWrapperNode, iconAndTextContainerNode, iconNode, textNode <br>
 * This works in conjunction with the SizeMixin. DO mix this in after the SizeMixin.
 *
 * @module mw-form/mixins/IconAndTextSizingMixin
 *
 * @copyright Copyright 2014 The MathWorks, Inc.
 */
define([
    "dojo/_base/declare",
    "dojo/dom-style",
    "mw-form/mixins/property/SizeMixin"
], function (declare, domStyle, SizeMixin) {

    var IconAndTextSizingMixin = declare(null, {
        //Avoid calculations for clipped content by using a fixed value for border + padding for performance reasons
        _paddingAndBorder: 6,

        _setSize: function (sizeType, value) {
            this.inherited(arguments);
            // Do not attempt DOM sizing during the widget construction phase
            if (!this._started) {
                return;
            }

            var valueForDom = "";

            if (value === "auto" || value === "100%") {
                valueForDom = value;
                this._setSpecialSizeOnAdditionalNodes(sizeType, "none");
            } else {
                // user provided positive value for width or height
                valueForDom = this._getAdjustedSize(sizeType, value, this.domNode);

                this._setSpecialSizeOnAdditionalNodes(sizeType, (parseFloat(valueForDom) - this._paddingAndBorder) +"px");
            }
            this.contentWrapperNode.style[sizeType] = "100%";

        },

        // Helper method which makes additional adjustments to the widget's dom based on
        // the width/height value
        _setSpecialSizeOnAdditionalNodes: function (sizeType, value) {

            if (sizeType === "width") {
                this.iconAndTextContainerNode.style.maxWidth = value;
            } else if (sizeType === "height") {
                this.textNode.style.maxHeight = value;
            }
        }
    });
    IconAndTextSizingMixin._dependencies = [{mixin:SizeMixin, orderDependent: true}];

    return IconAndTextSizingMixin;
});
